import { useEffect } from "react";

/** Tiny redirect to the standalone "Registros OPC" referral landing HTML. */
const RegistrosOpcRedirect = () => {
  useEffect(() => {
    window.location.replace("/registrosopc.html");
  }, []);
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#0D1B2A",
      color: "#C9A84C",
      fontFamily: "system-ui, sans-serif",
      fontSize: "14px",
      letterSpacing: "2px",
      textTransform: "uppercase",
    }} data-testid="registros-opc-loading">
      Cargando…
    </div>
  );
};

export default RegistrosOpcRedirect;
